import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceFileName'
})
export class ReplaceFileName implements PipeTransform {
    transform(name: string): string {
        return name.split('.')[2];
    }
}
